module.exports = __webpack_public_path__ + "static/media/medical.e0b6923b.svg";